import { render } from "./ValidationCode.vue?vue&type=template&id=5a2c4f52&scoped=true"
import script from "./ValidationCode.vue?vue&type=script&lang=js"
export * from "./ValidationCode.vue?vue&type=script&lang=js"

import "./ValidationCode.vue?vue&type=style&index=0&id=5a2c4f52&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2c4f52"]])

export default __exports__